/**
 * Storage Manager Utility
 * Provides functions to manage localStorage clearing on page exit
 */

// Items to clear when user leaves (cart/booking related)
const ITEMS_TO_CLEAR = [
    'cartItems',
    'venueData',
    'Product_Service',
    'countdownEndTime',
    'selectedPitch',
    'bookingData',
    'tempBookingState'
];

// Items to preserve (user authentication and preferences)
const ITEMS_TO_PRESERVE = [
    'token',
    'userPreferences',
    'language',
    'theme'
];

/**
 * Clear specific localStorage items while preserving important data
 */
export const clearTemporaryStorage = () => {
    try {
        // Clear specific items
        ITEMS_TO_CLEAR.forEach(item => {
            localStorage.removeItem(item);
        });

        // Clear all sessionStorage
        sessionStorage.clear();

        //console.log('🧹 Temporary storage cleared successfully');
        return true;
    } catch (error) {
        //console.error('❌ Error clearing temporary storage:', error);
        return false;
    }
};

/**
 * Clear all localStorage (use with caution)
 */
export const clearAllStorage = () => {
    try {
        localStorage.clear();
        sessionStorage.clear();
        //console.log('🧹 All storage cleared');
        return true;
    } catch (error) {
        console.error('❌ Error clearing all storage:', error);
        return false;
    }
};

/**
 * Get current storage usage info
 */
export const getStorageInfo = () => {
    const info = {
        localStorage: {
            items: Object.keys(localStorage),
            size: JSON.stringify(localStorage).length
        },
        sessionStorage: {
            items: Object.keys(sessionStorage),
            size: JSON.stringify(sessionStorage).length
        }
    };

    //console.log('📊 Storage Info:', info);
    return info;
};

/**
 * Check if user has important data that shouldn't be cleared
 */
export const hasImportantData = () => {
    return ITEMS_TO_PRESERVE.some(item => localStorage.getItem(item) !== null);
};

export default {
    clearTemporaryStorage,
    clearAllStorage,
    getStorageInfo,
    hasImportantData,
    ITEMS_TO_CLEAR,
    ITEMS_TO_PRESERVE
};
